import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token from localStorage for protected routes
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalize FastAPI/Pydantic 422 error shapes so every page's
// `err.response?.data?.detail` is always a renderable string. Pydantic v2
// wraps a @field_validator ValueError into a LIST of structured error dicts
// ({type, loc, msg, ...}) rather than the plain string most pages expect
// (from HTTPException(detail="...")) — rendering that array/object directly
// as a React child crashes the page to the ErrorBoundary. Fix it once, here,
// instead of at every call site across the app.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const detail = error?.response?.data?.detail;
    if (Array.isArray(detail)) {
      error.response.data.detail = detail
        .map((d) => (typeof d === "string" ? d : d?.msg || JSON.stringify(d)))
        .join("; ");
    } else if (detail && typeof detail === "object") {
      error.response.data.detail = detail.msg || JSON.stringify(detail);
    }
    return Promise.reject(error);
  },
);

export default api;
